<span class="tag">
  <mat-icon class="icon tag-{{tag}}" fontIcon="label"></mat-icon><span>{{tag}}</span>
</span>
